import { render, staticRenderFns } from "./viewAnnouncement.vue?vue&type=template&id=a0d9a704&"
import script from "./viewAnnouncement.vue?vue&type=script&lang=js&"
export * from "./viewAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VContainer,VSheet,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0d9a704')) {
      api.createRecord('a0d9a704', component.options)
    } else {
      api.reload('a0d9a704', component.options)
    }
    module.hot.accept("./viewAnnouncement.vue?vue&type=template&id=a0d9a704&", function () {
      api.rerender('a0d9a704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/Ess/Announcement/components/viewAnnouncement.vue"
export default component.exports